import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow cross-origin "Script error." noise (Cloudflare bot-check, injected
// dev overlays, etc.) before it reaches the CRA dev error-overlay. These
// events carry no message/filename/line — the browser masks them for security
// — so surfacing them as red-screen runtime errors is 100% false-positive.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (event) => {
      const msg = (event && event.message) || "";
      if (msg === "Script error." || msg === "Script error") {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true, // capture — beat react-error-overlay's own listener
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
